import script from "./success.vue?vue&type=script&setup=true&lang=js"
export * from "./success.vue?vue&type=script&setup=true&lang=js"

import "./success.vue?vue&type=style&index=0&id=231fea0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231fea0c"]])

export default __exports__